__turbopack_context__.v({
  "authBezel": "ClientLoginPage-module__DoEImW__authBezel",
  "authBezelError": "ClientLoginPage-module__DoEImW__authBezelError",
  "authBezelLabel": "ClientLoginPage-module__DoEImW__authBezelLabel",
  "authBezelLeft": "ClientLoginPage-module__DoEImW__authBezelLeft",
  "authBezelReady": "ClientLoginPage-module__DoEImW__authBezelReady",
  "authBezelStatus": "ClientLoginPage-module__DoEImW__authBezelStatus",
  "barMuted": "ClientLoginPage-module__DoEImW__barMuted",
  "barPrimary": "ClientLoginPage-module__DoEImW__barPrimary",
  "bezelMark": "ClientLoginPage-module__DoEImW__bezelMark",
  "body": "ClientLoginPage-module__DoEImW__body",
  "brandContent": "ClientLoginPage-module__DoEImW__brandContent",
  "brandDescription": "ClientLoginPage-module__DoEImW__brandDescription",
  "brandField": "ClientLoginPage-module__DoEImW__brandField",
  "brandFoot": "ClientLoginPage-module__DoEImW__brandFoot",
  "brandHeading": "ClientLoginPage-module__DoEImW__brandHeading",
  "brandHeadingAccent": "ClientLoginPage-module__DoEImW__brandHeadingAccent",
  "brandMedallion": "ClientLoginPage-module__DoEImW__brandMedallion",
  "brandMeta": "ClientLoginPage-module__DoEImW__brandMeta",
  "brandMetaSep": "ClientLoginPage-module__DoEImW__brandMetaSep",
  "brandMetaTag": "ClientLoginPage-module__DoEImW__brandMetaTag",
  "brandPanel": "ClientLoginPage-module__DoEImW__brandPanel",
  "brandRing": "ClientLoginPage-module__DoEImW__brandRing",
  "brandRingInner": "ClientLoginPage-module__DoEImW__brandRingInner",
  "brandRingMid": "ClientLoginPage-module__DoEImW__brandRingMid",
  "brandRingOuter": "ClientLoginPage-module__DoEImW__brandRingOuter",
  "brandTop": "ClientLoginPage-module__DoEImW__brandTop",
  "candleDown": "ClientLoginPage-module__DoEImW__candleDown",
  "candleUp": "ClientLoginPage-module__DoEImW__candleUp",
  "canvasBrand": "ClientLoginPage-module__DoEImW__canvasBrand",
  "canvasMark": "ClientLoginPage-module__DoEImW__canvasMark",
  "canvasOrbA": "ClientLoginPage-module__DoEImW__canvasOrbA",
  "canvasOrbB": "ClientLoginPage-module__DoEImW__canvasOrbB",
  "canvasVignette": "ClientLoginPage-module__DoEImW__canvasVignette",
  "canvasWord": "ClientLoginPage-module__DoEImW__canvasWord",
  "chartArea": "ClientLoginPage-module__DoEImW__chartArea",
  "chartBackdrop": "ClientLoginPage-module__DoEImW__chartBackdrop",
  "chartDot": "ClientLoginPage-module__DoEImW__chartDot",
  "chartGrid": "ClientLoginPage-module__DoEImW__chartGrid",
  "chartLine": "ClientLoginPage-module__DoEImW__chartLine",
  "chartLineMuted": "ClientLoginPage-module__DoEImW__chartLineMuted",
  "csrfHint": "ClientLoginPage-module__DoEImW__csrfHint",
  "csrfRetry": "ClientLoginPage-module__DoEImW__csrfRetry",
  "dismissBtn": "ClientLoginPage-module__DoEImW__dismissBtn",
  "divider": "ClientLoginPage-module__DoEImW__divider",
  "dividerLine": "ClientLoginPage-module__DoEImW__dividerLine",
  "dividerText": "ClientLoginPage-module__DoEImW__dividerText",
  "errorAlert": "ClientLoginPage-module__DoEImW__errorAlert",
  "errorContent": "ClientLoginPage-module__DoEImW__errorContent",
  "errorIcon": "ClientLoginPage-module__DoEImW__errorIcon",
  "errorText": "ClientLoginPage-module__DoEImW__errorText",
  "errorTitle": "ClientLoginPage-module__DoEImW__errorTitle",
  "fieldIcon": "ClientLoginPage-module__DoEImW__fieldIcon",
  "fieldLabel": "ClientLoginPage-module__DoEImW__fieldLabel",
  "fieldRow": "ClientLoginPage-module__DoEImW__fieldRow",
  "forgotLink": "ClientLoginPage-module__DoEImW__forgotLink",
  "formActions": "ClientLoginPage-module__DoEImW__formActions",
  "formCard": "ClientLoginPage-module__DoEImW__formCard",
  "formContainer": "ClientLoginPage-module__DoEImW__formContainer",
  "formFields": "ClientLoginPage-module__DoEImW__formFields",
  "formFooter": "ClientLoginPage-module__DoEImW__formFooter",
  "formFootnote": "ClientLoginPage-module__DoEImW__formFootnote",
  "formHeader": "ClientLoginPage-module__DoEImW__formHeader",
  "formKicker": "ClientLoginPage-module__DoEImW__formKicker",
  "formSide": "ClientLoginPage-module__DoEImW__formSide",
  "formSubtitle": "ClientLoginPage-module__DoEImW__formSubtitle",
  "formTitle": "ClientLoginPage-module__DoEImW__formTitle",
  "glassCell": "ClientLoginPage-module__DoEImW__glassCell",
  "glassChrome": "ClientLoginPage-module__DoEImW__glassChrome",
  "glassChromeLeft": "ClientLoginPage-module__DoEImW__glassChromeLeft",
  "glassChromeRight": "ClientLoginPage-module__DoEImW__glassChromeRight",
  "glassClock": "ClientLoginPage-module__DoEImW__glassClock",
  "glassLayout": "ClientLoginPage-module__DoEImW__glassLayout",
  "glassLive": "ClientLoginPage-module__DoEImW__glassLive",
  "glassMain": "ClientLoginPage-module__DoEImW__glassMain",
  "glassMark": "ClientLoginPage-module__DoEImW__glassMark",
  "glassPaneHead": "ClientLoginPage-module__DoEImW__glassPaneHead",
  "glassPaneMeta": "ClientLoginPage-module__DoEImW__glassPaneMeta",
  "glassShell": "ClientLoginPage-module__DoEImW__glassShell",
  "glassStrip": "ClientLoginPage-module__DoEImW__glassStrip",
  "glassSvg": "ClientLoginPage-module__DoEImW__glassSvg",
  "glassTitle": "ClientLoginPage-module__DoEImW__glassTitle",
  "legalBar": "ClientLoginPage-module__DoEImW__legalBar",
  "legalBarDot": "ClientLoginPage-module__DoEImW__legalBarDot",
  "legalBarLink": "ClientLoginPage-module__DoEImW__legalBarLink",
  "legalLink": "ClientLoginPage-module__DoEImW__legalLink",
  "medallionGlow": "ClientLoginPage-module__DoEImW__medallionGlow",
  "mobileLogo": "ClientLoginPage-module__DoEImW__mobileLogo",
  "navBrandText": "ClientLoginPage-module__DoEImW__navBrandText",
  "nt-r26-none": "ClientLoginPage-module__DoEImW__nt-r26-none",
  "passwordItem": "ClientLoginPage-module__DoEImW__passwordItem",
  "ringRipple": "ClientLoginPage-module__DoEImW__ringRipple",
  "riseIn": "ClientLoginPage-module__DoEImW__riseIn",
  "secondaryBtn": "ClientLoginPage-module__DoEImW__secondaryBtn",
  "shakeIn": "ClientLoginPage-module__DoEImW__shakeIn",
  "srOnly": "ClientLoginPage-module__DoEImW__srOnly",
  "statusPulse": "ClientLoginPage-module__DoEImW__statusPulse",
  "submitBtn": "ClientLoginPage-module__DoEImW__submitBtn",
  "submitBtnDisabled": "ClientLoginPage-module__DoEImW__submitBtnDisabled",
  "trustItem": "ClientLoginPage-module__DoEImW__trustItem",
  "trustItemIcon": "ClientLoginPage-module__DoEImW__trustItemIcon",
  "trustStrip": "ClientLoginPage-module__DoEImW__trustStrip",
  "valueBlock": "ClientLoginPage-module__DoEImW__valueBlock",
  "valueBlockLabel": "ClientLoginPage-module__DoEImW__valueBlockLabel",
  "valueIcon": "ClientLoginPage-module__DoEImW__valueIcon",
  "valueLine": "ClientLoginPage-module__DoEImW__valueLine",
  "valueList": "ClientLoginPage-module__DoEImW__valueList",
  "valueText": "ClientLoginPage-module__DoEImW__valueText",
  "waitBanner": "ClientLoginPage-module__DoEImW__waitBanner",
  "waitClock": "ClientLoginPage-module__DoEImW__waitClock",
  "waitCopy": "ClientLoginPage-module__DoEImW__waitCopy",
  "waitFill": "ClientLoginPage-module__DoEImW__waitFill",
  "waitHeader": "ClientLoginPage-module__DoEImW__waitHeader",
  "waitHint": "ClientLoginPage-module__DoEImW__waitHint",
  "waitIcon": "ClientLoginPage-module__DoEImW__waitIcon",
  "waitMessage": "ClientLoginPage-module__DoEImW__waitMessage",
  "waitTimerRow": "ClientLoginPage-module__DoEImW__waitTimerRow",
  "waitTitle": "ClientLoginPage-module__DoEImW__waitTitle",
  "waitTrack": "ClientLoginPage-module__DoEImW__waitTrack",
  "workspaceShell": "ClientLoginPage-module__DoEImW__workspaceShell",
});
